import React from "react";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "../Redux";
import i18n from "../Translations";
// eslint-disable-next-line no-undef
import Root from "./Root";

const App = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <I18nextProvider i18n={i18n}>
                    <Root />
                </I18nextProvider>
            </PersistGate>
        </Provider>
    );
};
export default App;
